export enum SelectOption {
  mandatory = 'mandatory',
  locked = 'locked',
  optional = 'optional',
}

export type TimeAggregationEnum = string;

export interface ColumnChooserColumnOption {
  key: string;
  name: string;
  type?: string;
  helpTopic?: string;
  forbiddenTimeGrains?: TimeAggregationEnum[];
  selectOption?: SelectOption;
}

export interface ColumnChooserCategory {
  name: string;
  type: string;
  options: ColumnChooserColumnOption[];
}
